import { Module } from 'vuex'

import { DashboardUseCase } from '@/application/dashboard/dashboardUseCase'
import { DailySoluition } from '@/domain/entities/dashboard/dailySolution'
import { LanguageStatistics } from '@/domain/entities/problem/languageStatistics'
import { DashboardRepository } from '@/domain/repositories/dashboard/DashboardRepository'

interface StatisticsState {
  userLanguageStatisticsList: LanguageStatistics[]
  userDailySolutionList: DailySoluition[][]
  isLoading: boolean
  error: Error | null
}

export const statisticsModule = (repository: DashboardRepository): Module<StatisticsState, any> => {
  const usecase = new DashboardUseCase(repository)

  return {
    namespaced: true,
    state: {
      userLanguageStatisticsList: [],
      userDailySolutionList: [],
      isLoading: false,
      error: null
    },
    mutations: {
      addUserLanguageStatistics(state, { statistics }: { statistics: LanguageStatistics }) {
        state.userLanguageStatisticsList.push(statistics)
      },
      addUserDailySolution(state, { daily }: { daily: DailySoluition[] }) {
        state.userDailySolutionList.push(daily)
      },
      removeUserStatistics(state) {
        state.userDailySolutionList.splice(0)
        state.userLanguageStatisticsList.splice(0)
      },
      removeTargetUsers(state) {
        state.userDailySolutionList.splice(1)
        state.userLanguageStatisticsList.splice(1)
      },
      setIsLoading(state, isLoading: boolean) {
        state.isLoading = isLoading
      },
      setError(state, error: Error | null) {
        state.error = error
      }
    },
    actions: {
      async addUserStatistics({ state, commit }, { userId }: { userId: string }) {
        commit('setIsLoading', true)
        commit('setError', null)

        try {
          const res = await usecase.getUserStatistics(userId)
          commit('addUserLanguageStatistics', {
            statistics: res
          })

          const res2 = await usecase.getDailySolutionList(userId)

          commit('addUserDailySolution', {
            daily: res2
          })
        } catch (e) {
          commit('setError', e)
        } finally {
          commit('setIsLoading', false)
        }
      }
    },
    getters: {
      userLanguageStatisticsList: state => state.userLanguageStatisticsList,
      userDailySolutionList: state => state.userDailySolutionList,
      isLoading: state => state.isLoading,
      error: state => state.error
    }
  }
}
